export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f41208007b2eb2b75c22e93a177397b5b243773f3&name=fetchTypeahead!'